import React from 'react';
import Img1 from '../../images/Concrete repair/concrete-repair.jpg';
import { Link }  from 'react-router-dom';

export default () => (
	<div className='section3-CN'>

	<div class="service-split">
		<div>
		<h4>
		Concrete Repair
		</h4>
		<p>Address concrete damage effectively with our concrete repair services. We assess and repair concrete structures, addressing cracks, spalls, and more. Reinforcement and joint repair are also part of our offerings, enhancing strength and functionality. Our goal is to prolong the lifespan of concrete elements, saving you time and money in the long run.
		</p>
		</div>
	</div>
	<div className='editorial-template'>
		<hr className="editorial-underline"></hr>
		<div class="project-split">
		<img class="service-split-img" src={Img1}></img>
	</div>
</div>
<Link to='/servicepage'>
			<button className="see-more-button">See More Services</button>
	</Link>
	</div>
);
